import { Avatar, Chip, ListItemAvatar } from "@material-ui/core";
import { Lock, LockOpen } from "@material-ui/icons";
import Business from "@material-ui/icons/Business";
import { Collections } from "Collections";
import { useOrgIdLocalStorage } from "components/OrgProvider";
import { setFreeStandardSubscription } from "components/PaymentManager";
import * as FirebaseConfigs from 'FirebaseConfigs';
import { getTrial } from "hooks/useSubscriptionStatus";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { noOrgNameText, Org } from "models/Org";
import { OrgSubscription } from "models/OrgSubscription";
import { useSnackbar } from "notistack";
import React from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { ListScreen } from "./ListScreen";


const getName = (entry: Org) => noOrgNameText(entry?.name?.text)

export function OrgsScreen() {
    const [, setOrgId] = useOrgIdLocalStorage()
    const { enqueueSnackbar } = useSnackbar()
    const [orgSubscriptions, loadingOrgSubscriptions] = useCollection<OrgSubscription>(FirebaseConfigs.persistedDb.collection('OrgSubscriptions'))
    return (
        <>
            <ListScreen<Org>
                title="Organisasjoner"
                collectionName={Collections.ORGS}
                noEntriesText="Det er ingen organisasjoner"
                fieldName="org"
                standardBackButton
                getName={getName}
                getErrorEvent={AnalyticsEvent.GET_ORGS_ERROR}
                onClickEntry={(entry) => setOrgId(entry.id)}
                getAvatar={(org) => {
                    return (
                        <ListItemAvatar>
                            <Avatar src={org.logo?.original.url || undefined}>
                                <Business />
                            </Avatar>
                        </ListItemAvatar>
                    )
                }}
                getSecondaryText={org => {
                    if (!org.owner) {
                        console.error(Object.keys(org))
                        console.error(JSON.stringify(org))
                        console.error(JSON.stringify(org.owner))
                    }
                    return org.owner?.appUser?.contactInfo?.name?.fullName
                }}
                getActions={(org) => {
                    const [trial] = getTrial(org)
                    const subscription = orgSubscriptions?.docs.find(sub => sub.id === org.data.id)
                    const subscribed = subscription?.data().status === "active"
                    const free = !!subscription?.data().adminOverrides.freeStandard.active
                    return (
                        <Chip
                            color={(subscribed || free) ? 'primary' : 'secondary'}
                            size="small"
                            label={loadingOrgSubscriptions ? 'Laster inn ...' : (subscribed ? 'Aktivt' : (free ? 'Gratis' : (trial ? 'Prøvetid' : 'Inaktivt')))}
                            onDelete={() => {
                                setFreeStandardSubscription(!free, org.data.id, enqueueSnackbar)
                            }}
                            disabled={loadingOrgSubscriptions}
                            deleteIcon={free ? <LockOpen /> : <Lock />}
                        />
                    )
                }}
            />
        </>
    )
}
